import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';

import { MatCardModule } from '@angular/material/card';

import { ProfileCardSize } from '../../types';
import { ProfileCardSizeEnum } from '../../constants';

@Component({
  selector: 'wcg-profile-card',
  imports: [MatCardModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./profile-card.component.css'],
  template: `
    <mat-card
      class="profile-card__container !rounded-[12px] profile-card__container-{{
        size()
      }}"
      appearance="outlined"
      [attr.aria-busy]="loading() ? 'true' : null"
    >
      <mat-card-header>
        <mat-card-title>
          <ng-content select="[wcgProfileCardHeader]" />
        </mat-card-title>
        <ng-content select="[wcgProfileCardHeaderButton]" />
      </mat-card-header>
      <mat-card-content>
        <ng-content select="[wcgProfileCardContent]" />
      </mat-card-content>
    </mat-card>
  `,
})
export class ProfileCardComponent {
  size = input<ProfileCardSize>(ProfileCardSizeEnum.Medium);
  loading = input(false);
}
